import {
  BookOpen,
  Database,
  FileText,
  Folder,
  GitBranch,
  Image,
  Tags,
  User,
  Workflow,
  Wrench,
} from "lucide-react";
import type { ElementType } from "react";
import type { WorkflowReferenceKind } from "@/types/workflow-reference.types";

export const ICON_BY_KIND: Record<WorkflowReferenceKind, ElementType> = {
  knowledge: BookOpen,
  folder: Folder,
  tag: Tags,
  category: Tags,
  media_asset: Image,
  connector: Database,
  workflow: Workflow,
  mcp_tool: Wrench,
  kg_entity: GitBranch,
  principal_user: User,
  aic_model: Wrench,
};

export const FALLBACK_REFERENCE_ICON = FileText;

export const UNAVAILABLE_KEY_BY_KIND: Partial<Record<WorkflowReferenceKind, string>> = {
  knowledge: "drawer.reference.unavailable_knowledge",
  folder: "drawer.reference.unavailable_folder",
  tag: "drawer.reference.unavailable_tag",
  category: "drawer.reference.unavailable_category",
  media_asset: "drawer.reference.unavailable_media_asset",
  connector: "drawer.reference.unavailable_connector",
  workflow: "drawer.reference.unavailable_workflow",
  mcp_tool: "drawer.reference.unavailable_mcp_tool",
  kg_entity: "drawer.reference.unavailable_kg_entity",
  principal_user: "drawer.reference.unavailable_principal_user",
  aic_model: "drawer.reference.unavailable_aic_model",
};

export const SEARCH_KEY_BY_KIND: Partial<Record<WorkflowReferenceKind, string>> = {
  knowledge: "drawer.reference.search_knowledge",
  folder: "drawer.reference.search_folder",
  tag: "drawer.reference.search_tag",
  category: "drawer.reference.search_category",
  media_asset: "drawer.reference.search_media",
  connector: "drawer.reference.search_connector",
  workflow: "drawer.reference.search_workflow",
  mcp_tool: "drawer.reference.search_mcp_tool",
  kg_entity: "drawer.reference.search_kg_entity",
  principal_user: "drawer.reference.search_principal_user",
  aic_model: "drawer.reference.search_aic_model",
};
